import { ENABLE_ADD_INGREDIENT_DIALOG_REDESIGN } from "../../../config/constants";
import RecipeAddIngredientModalLegacy from "./legacy/RecipeAddIngredientModalLegacy";
import RecipeAddIngredientModalNew from "./RecipeAddIngredientModalNew";
import { RecipeAddIngredientModalProps } from "./types/recipeAddIngredient.types";

const RecipeAddIngredientModal = (props: RecipeAddIngredientModalProps) => {
  return ENABLE_ADD_INGREDIENT_DIALOG_REDESIGN ? (
    <RecipeAddIngredientModalNew {...props} />
  ) : (
    <RecipeAddIngredientModalLegacy {...props} />
  );
};

export default RecipeAddIngredientModal;
